
export const INVALID_FILE_NAME_PATTERN = /^\[object\s+.+\]$/i;

export const MIME_TYPE_PATTERN = /^[a-z0-9!#$&^_.+-]+\/[a-z0-9!#$&^_.+-]+$/i;

export const MIME_SUBTYPE_LABEL_ALIASES: Record<string, string> = {
    'vnd.android.package-archive': 'APK',
    'vnd.openxmlformats-officedocument.wordprocessingml.document': 'DOCX',
    'vnd.openxmlformats-officedocument.wordprocessingml.template': 'DOTX',
    'vnd.ms-word.document.macroenabled.12': 'DOCM',
    'vnd.ms-word.template.macroenabled.12': 'DOTM',
    'vnd.ms-excel': 'XLS',
    'vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'XLSX',
    'vnd.openxmlformats-officedocument.spreadsheetml.template': 'XLTX',
    'vnd.ms-excel.sheet.macroenabled.12': 'XLSM',
    'vnd.ms-powerpoint': 'PPT',
    'vnd.openxmlformats-officedocument.presentationml.presentation': 'PPTX',
    'vnd.openxmlformats-officedocument.presentationml.slideshow': 'PPSX',
    'vnd.ms-powerpoint.presentation.macroenabled.12': 'PPTM',
    'x-7z-compressed': '7Z',
    'x-rar-compressed': 'RAR',
    'x-zip-compressed': 'ZIP',
    'zip': 'ZIP',
    'octet-stream': 'BIN',
    'x-msdownload': 'EXE',
    'plain': 'TXT',
    'csv': 'CSV',
    'json': 'JSON',
    'xml': 'XML',
    'rtf': 'RTF'
};

export const MAX_TOTAL_FILE_SIZE_BYTES = 3 * 1024 * 1024 * 1024;
